export default __webpack_public_path__ + "static/media/LamboReveal.6ced5cc4.mp4";